/**
 * Login.jsx url: /login
 * import Form is used for form fields and styling
 * import Button is the button field from react bootstrap
 * import axios calling server
 * import ErrorMessage for displaying errors from server
 */
import React, {useState} from 'react';
import {Link, useHistory} from "react-router-dom"
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../style/loginStyle.css';
import axios from 'axios';
import ErrorMessage from '../Misc/ErrorMessage';


function Login() {
    /**keeping tracking of error messages from server*/
    const [errorMessage, setErrorMessage] = useState(null);
    /**history will be used to forward the user if login cookie is already avaiable*/
    const history = useHistory();
    /**get the cookie "link2rsvp"*/
    const userEmail = getCookie("link2rsvp");
    
    if(userEmail) {
        alert("Welcome back " + userEmail);
        history.push("/home");
    }
    
    

//Cookies
    /**
     * setCoolie() creates a cookie
     * @param cname = name of the cookie being created
     * @param cvalue = value of the cookie being created
     * @param exdays = number of days till expiration
     */
    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    /**
     * @param cname = name of cookie being looked for
     */
    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }
        return null;
      }

//End of Cookies
      /**
       * takes in email and password from login form.
       * sends a request to server, checking if user exist
       * if succsufull, will log user in.
       * if error found, will display error
       */
    async function login(e) {
        e.preventDefault();
        const formEmail = e.target.email.value;
        const formPassword = e.target.password.value;

        const loginData = {
            email: formEmail,
            password: formPassword,
        };

        try {
            await axios.post("https://link2rsvp.herokuapp.com/auth/login", loginData);
            setCookie("link2rsvp", e.target.email.value, 1);
        } catch (err){
            if (err.response) {
                if (err.response.data.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
            return;
        }
        

        history.push("/home");


    }

    return (
        <div>
            {
                /**
                 * error message conditional rendered
                 */
            }
            {
                errorMessage &&  (
                <ErrorMessage 
                message={errorMessage} 
                clear={() => setErrorMessage(null)}
                />
                )}

            <div id="signin">
                <h3 id="wel">Log Into LINK2RSVP</h3>
                <Form onSubmit={login} id="login-form"> 
                    <Form.Group className="mb-3">
                    <label htmlFor="email">Email</label>
                        <Form.Control
                            id="email"
                            type="email"
                            name="email"
                            placeholder="Enter email"
                            />
                            
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <label htmlFor="password">Password</label>
                        <Form.Control
                            id="password"
                            type="password"
                            name="password"
                            placeholder="Enter Password"
                            />
                    </Form.Group>
                    <label htmlFor="login-btn" hidden>login-btn</label>
                    <Button name="login-btn" id="signinbutton" variant="secondary" type="submit" testid="login-btn" style={{backgroundColor: "#890E32"}}>
                        Log in
                    </Button>
                    <p className="forgot">
                        <Link to="/passwordreset">Forgot Password?</Link>
                    </p>
                </Form>
                <h4>Or Create an Account</h4>
                <Link to="/signup">
                <Button  id="signupbutton" variant="light" style={{backgroundColor: "white", color: "black"}}>
                     Create an account
                </Button>
                </Link>
            </div>
        </div>
    );
}
export default Login;